import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import './jss';
import './icons';

import React from 'react';
import ReactDOM from 'react-dom';
import App from './app/index';
import i18n from './i18n';

i18n();

ReactDOM.render(<App/>, document.querySelector('#app'));



// WEBPACK FOOTER //
// ./src/index.js